if (!customElements.get('product-suggestions')) {
  class ProductSuggestions extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    connectedCallback() {
      this.loadRecommendations();
    }

    loadRecommendations(fromEvent = false) {
      let url = this.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const match = text.match(/<product-suggestions[\s\S]*?<\/product-suggestions>/);

          if (match) {
            const suggestionsHTML = match[0]; // This contains the matched <product-suggestions> element and its content.
            const html = document.createElement('div');
            html.innerHTML = suggestionsHTML;

            const recommendations = html.firstElementChild;

            if (
              recommendations &&
              recommendations.innerHTML.trim().length
            ) {
              this.innerHTML = recommendations.innerHTML;
              this.suggestionsTrigger = this.querySelector('[data-suggestions-trigger]');

              if (this.suggestionsTrigger != null) {
                this.suggestionsTrigger.addEventListener('click', () => {
                  this.updateRecommendations();
                });
              }
            }
          };
        })
        .catch(e => {
          console.error(e);
        });
    }

    updateRecommendations() {
      this.suggestionsDrawer = document.querySelector('.suggestions-drawer');
      this.suggestionsDrawerProducts = this.suggestionsDrawer.querySelector('.suggestions-drawer__products');
      this.productSuggestionsBody = this.querySelector('.suggestions-drawer__body');

      this.suggestionsDrawerProducts.innerHTML = this.productSuggestionsBody.innerHTML;
      this.suggestionsDrawer.classList.add('open');
      this.cartDrawer.classList.add('mobile-open');

      document.body.classList.add('open-suggestions');
    }
  }

  customElements.define('product-suggestions', ProductSuggestions);
}

// Add the document-level click event listener to handle drawer visibility
document.addEventListener('click', (event) => {
  const suggestionsDrawer = document.querySelector('.suggestions-drawer');
  const cartDrawer = document.querySelector('cart-drawer');

  const isTrigger = event.target.closest('.line-item__suggestions');
  const isInsideDrawer = event.target.closest('.suggestions-drawer');
  const isToggle = event.target.closest('.suggestions-drawer__toggle');

  // If the click is not on a trigger, not inside the drawer, or on the toggle, close the drawer
  if (!isTrigger && !isInsideDrawer || isToggle) {
    suggestionsDrawer.classList.remove('open');
    cartDrawer.classList.remove('mobile-open');
    document.body.classList.remove('open-suggestions');
  }
});

document.addEventListener('variant:add', () => {
  const productId = event.detail.productId;

  setTimeout(() => {
    const currentSuggestions = document.querySelector(`product-suggestions[data-id="${productId}"]`);
    const currentSuggestionsTrigger = currentSuggestions.querySelector('[data-suggestions-trigger]');

    if (currentSuggestionsTrigger != null) {
      currentSuggestions.updateRecommendations();
    };
  }, 1500);
});
